<template>
  <div>
    <input class="trace-input" type="hidden" ref="traceInput" :value="JSON.stringify(this.exceptionData)" />
  </div>
</template>
<script>
  /**
   * One can find the documentation on below options for customisation
   * https://github.com/shakee93/vue-toasted
   */
  export default {
    name: 'FlashMessage',
    props: {
      size: {
        type: String,
        default: 'is-size-6'
      },
      hideCloseBtn: {
        type: Boolean,
        default: false
      },
      badge: {
        type: [String, Boolean],
        required: false,
        default: false
      }
    },
    data () {
      return {
        exceptionData: ''
      }
    },
    created () {
      window.events.$on('flash', (message, css, hideCloseBtn, duration) => this.display(message, css, hideCloseBtn, duration))
    },
    methods: {
      /**
       * Displays notification message globally
       * @param {string} message message to display
       * @param {string} css properties to use
       * @param {boolean} hideCloseBtn flag to hide close btn
       * @param {integer} duration flag to set duration for display
       * @returns {null}
       */
      display (message, css = 'is-success', hideCloseBtn, duration) {
        this.$toasted.show(`${message}`, {
          className: `${css}`,
          containerClass: 'toast-container',
          icon: this.getIcon(css),
          theme: 'outline',
          singleton: true,
          duration: duration || 2500,
          iconPack: 'fontawesome',
          position: 'top-right',
          fullWidth: false,
          keepOnHover: true
        })
      },
      /**
       * Copy error from toast
       * @return {void}
       */
      copyError () {
        this.$refs.traceInput.setAttribute('type', 'text')
        this.$refs.traceInput.select()
        document.execCommand('copy')
        this.$refs.traceInput.setAttribute('type', 'hidden')
      },
      /**
       * Get the icon class to render on the left of the Notification
       * @param {string} css The default CSS class passed to the notification i.e is-success, is-warning or is-danger
       * @return {string}
       */
      getIcon (css) {
        switch (css) {
          case 'is-warning':
            return 'fa-exclamation-triangle'
          case 'is-info':
            return 'fa-info-circle'
          case 'is-danger':
            return 'fa-ban'
          default:
            return 'fa-check'
        }
      }
    }
  }
</script>
<!-- Global CSS Begins -->
<style lang="scss">
  $success: #16be85;
  $danger: #fb492c;
  $info: #31AAE1;
  $warning: #fb922c;
  $bg-color: #fff;

  .toast-container {
    min-width: 25%;
    max-width: 50%;

    &.top-right {
      right: 1%;
    }
    .toasted.outline {
      color: $bg-color;
      opacity: 0.8 !important;
      padding: 10px 15px;
      font-weight: 600;
      justify-content: flex-start;
      border-radius: 5px;
      background-color: $bg-color;

      &.is-success {
        border: none;
        background-color: $success;
      }
      &.is-danger {
        border: none;
        background-color: $danger;
      }
      &.is-info {
        border: none;
        background-color: $info;
      }
      &.is-warning {
        border: none;
        background-color: $warning;
      }
    }
    .toasted .fa, .toasted .fab, .toasted .far,
    .toasted .fas, .toasted .material-icons, .toasted .mdi {
      font-size: 30px;
    }

    /*Mobile view*/
    @media screen and (max-width: 767px) {
      left: 1%;
      max-width: 100%;
    }
  }
</style>
<!-- Global CSS Ends -->



// WEBPACK FOOTER //
// src/components/FlashMessage.vue